import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: '#007BFF',
        secondary: '#FFC107',
        accent: '#FFAB00',
        error: '#FF5252',
        info: '#2196F3',
        success: '#7CB342',
        warning: '#FFC107'
      },
    },
  },
});
